import React, { createContext, useState, useEffect, useCallback, useRef } from 'react';
import api from '../components/api';

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(() => {
    try {
      var saved = localStorage.getItem('auth');
      if (!saved) return {};
      var parsed = JSON.parse(saved);
      // Accept both old format (with token) and new format (UI hints only)
      // Old format token is used by api.js interceptor as Authorization header fallback
      if (parsed.username && parsed.roles) return parsed;
      return {};
    } catch(e) { return {}; }
  });

  // On app mount: refresh permissions + screens from DB so admin changes take effect
  const permRefreshed = useRef(false);
  useEffect(() => {
    if (!auth?.username || permRefreshed.current) return;
    permRefreshed.current = true;
    api.get(process.env.REACT_APP_URL + '/users/session-check')
      .then(function(r) {
        if (r.data && r.data.permissions) {
          setAuth(function(prev) {
            return Object.assign({}, prev, {
              permissions: r.data.permissions,
              allowedScreens: r.data.screens || [],
              roles: r.data.roles || prev.roles,
            });
          });
        }
      })
      .catch(function() { /* 401 handled by api interceptor */ });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Sync to localStorage whenever auth changes
  useEffect(() => {
    if (auth && auth.username && auth.roles) {
      localStorage.setItem('auth', JSON.stringify(auth));
    } else {
      // Logged out — clear all storages
      localStorage.removeItem('auth');
      sessionStorage.removeItem('auth');
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('lu');
      sessionStorage.removeItem('saadhakProfile');
    }
  }, [auth]);

  // Expose clearAuth for logout from anywhere
  var clearAuth = useCallback(function() {
    setAuth({});
    localStorage.removeItem('auth');
    sessionStorage.removeItem('auth');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('lu');
    sessionStorage.removeItem('saadhakProfile');
  }, []);

  return (
    <AuthContext.Provider value={{ auth, setAuth, clearAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
